import { instance } from "libs/api";

import { ApiRoutesOffers } from "../../constants";
import {
  CreateOfferBody,
  CreateOfferResponse
} from "./createSpecialOffer.types";

export const requestCreateOffer = async (
  body: CreateOfferBody
): Promise<CreateOfferResponse> => {
  return await instance.post(ApiRoutesOffers.SpecialOffers, body);
};
